import {Theme} from "@mui/material";

export const locationPaperStyle = (theme: Theme) => ({
    p: 3,
    mb: 3,
    width: 486,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 1,
    borderRadius: 2,
    border: "1px solid",
    borderColor: theme.palette.grey[300],
    backgroundColor: theme.palette.background.paper,
    position: "relative"
});

export const locationGroupBadgeStyle = {
    height: "32px",
    padding: "4px 6px",
    borderRadius: "8px",
    border: "1px solid rgba(72, 51, 89, 0.20)",
    backgroundColor: "#F5F5FE",
    color: "#3F3273",
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 400
}